(function () {
  'use strict';

  // Announcement bar rotation (mobile)
  var messages = ['WORLDWIDE SHIPPING', 'FREE SHIPPING OVER €150'];
  var annEl = document.getElementById('announcement-text');
  if (annEl) {
    var annIdx = 0;
    setInterval(function () {
      annIdx = (annIdx + 1) % messages.length;
      annEl.textContent = messages[annIdx];
    }, 4000);
  }

  // Mobile menu toggle
  var mobileBtn = document.getElementById('mobile-menu-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', function () {
      var open = !mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden', open);
      mobileBtn.textContent = open ? 'MENU' : 'CLOSE';
    });
  }

  // View mode toggle (ITEM / MODEL) — swaps product card images
  var viewMode = localStorage.getItem('rg-view-mode') || 'ITEM';

  function buildShopControls() {
    var isShopPage =
      window.location.pathname === '/' ||
      window.location.pathname.startsWith('/collections');
    if (!isShopPage) return;

    var viewHtml =
      '<div class="flex items-center gap-1.5">' +
      '<button id="view-item" class="font-mono uppercase tracking-[0.12em] text-[11px] leading-none transition-opacity">ITEM</button>' +
      '<span class="font-mono uppercase tracking-[0.12em] text-[11px] leading-none" style="opacity:0.4;">/</span>' +
      '<button id="view-model" class="font-mono uppercase tracking-[0.12em] text-[11px] leading-none transition-opacity">MODEL</button>' +
      '</div>';

    var sortHtml =
      '<div class="relative" id="sort-wrapper">' +
      '<button id="sort-trigger" class="font-mono uppercase tracking-[0.12em] text-[11px] leading-none transition-opacity" style="opacity:0.6;">SORT</button>' +
      '<div id="sort-menu" class="hidden absolute left-0 top-6 bg-white z-50 p-2 min-w-[12rem]" style="border:none;box-shadow:none;">' +
      '<button class="sort-opt block font-mono uppercase tracking-[0.12em] text-[11px] leading-none px-2 py-1.5 w-full text-left hover:opacity-100" data-sort="DEFAULT">DEFAULT</button>' +
      '<button class="sort-opt block font-mono uppercase tracking-[0.12em] text-[11px] leading-none px-2 py-1.5 w-full text-left hover:opacity-100" data-sort="PRICE_ASC">PRICE LOW TO HIGH</button>' +
      '<button class="sort-opt block font-mono uppercase tracking-[0.12em] text-[11px] leading-none px-2 py-1.5 w-full text-left hover:opacity-100" data-sort="PRICE_DESC">PRICE HIGH TO LOW</button>' +
      '</div>' +
      '</div>';

    var desktopEl = document.getElementById('shop-controls-desktop');
    var mobileViewEl = document.getElementById('shop-controls-mobile-view');
    var mobileSortEl = document.getElementById('shop-controls-mobile-sort');

    if (desktopEl) desktopEl.innerHTML = viewHtml + sortHtml;
    if (mobileViewEl) mobileViewEl.innerHTML = viewHtml;
    if (mobileSortEl) mobileSortEl.innerHTML = sortHtml;

    // Wire up view toggle
    applyViewMode(viewMode);
    ['view-item', 'view-model'].forEach(function (id) {
      document.querySelectorAll('#' + id).forEach(function (btn) {
        btn.addEventListener('click', function () {
          viewMode = id === 'view-item' ? 'ITEM' : 'MODEL';
          localStorage.setItem('rg-view-mode', viewMode);
          applyViewMode(viewMode);
        });
      });
    });

    // Wire up sort
    document.querySelectorAll('#sort-trigger').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var menu = btn.nextElementSibling;
        menu && menu.classList.toggle('hidden');
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('#sort-menu').forEach(function (m) { m.classList.add('hidden'); });
    });
    document.querySelectorAll('.sort-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sort = btn.dataset.sort;
        sortProducts(sort);
        document.querySelectorAll('.sort-opt').forEach(function (b) {
          b.style.textDecoration = b.dataset.sort === sort ? 'underline' : 'none';
          b.style.opacity = b.dataset.sort === sort ? '1' : '0.6';
        });
      });
    });
  }

  function applyViewMode(mode) {
    document.querySelectorAll('.product-card-img').forEach(function (img) {
      var primary = img.dataset.primarySrc;
      var secondary = img.dataset.secondarySrc;
      if (mode === 'MODEL' && secondary) {
        img.src = secondary;
      } else if (primary) {
        img.src = primary;
      }
    });
    document.querySelectorAll('#view-item').forEach(function (b) {
      b.style.opacity = mode === 'ITEM' ? '1' : '0.4';
    });
    document.querySelectorAll('#view-model').forEach(function (b) {
      b.style.opacity = mode === 'MODEL' ? '1' : '0.4';
    });
  }

  function sortProducts(sort) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var cards = Array.from(grid.children);
    if (sort === 'PRICE_ASC') {
      cards.sort(function (a, b) {
        return parsePriceCents(a) - parsePriceCents(b);
      });
    } else if (sort === 'PRICE_DESC') {
      cards.sort(function (a, b) {
        return parsePriceCents(b) - parsePriceCents(a);
      });
    }
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  function parsePriceCents(card) {
    var priceEl = card.querySelector('p span');
    if (!priceEl) return 0;
    return parseInt(priceEl.textContent.replace(/[^0-9]/g, ''), 10) || 0;
  }

  buildShopControls();
})();
